module.exports = __webpack_public_path__ + "static/media/backrest.7fd561ac.svg";